import { RefObject, useEffect } from 'react'

import { datadogLogs } from '@datadog/browser-logs'

/**
 * Plays/pauses a video in response to an externally-computed visibility signal — e.g. a carousel
 * observing its own container and passing the resulting `shouldPlay` boolean down to every card, so
 * they all react to the same visibility change together, rather than each card observing its own
 * individual visibility.
 */
export function useAutoplayOnIntersect(
  videoRef: RefObject<HTMLVideoElement>,
  userPausedRef: RefObject<boolean>,
  shouldPlay: boolean,
) {
  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    if (shouldPlay) {
      // Respect an explicit pause: don't resume autoplay when a video the user paused
      // scrolls back into view. Scrolling away leaves userPausedRef untouched, so only a
      // button click counts as intent.
      if (userPausedRef.current) return
      video.play().catch((error) => datadogLogs.logger.error('Recipe video play failed', error))
    } else {
      video.pause()
    }
  }, [videoRef, userPausedRef, shouldPlay])
}
